export default __webpack_public_path__ + "static/media/HyperLogo.6ec78e26.png";